import React, { useMemo, useState, useEffect, useCallback } from "react";
import { pdf } from '@react-pdf/renderer';
import { useTable } from "react-table";
import middleware from "../../../Api/Middleware";
import TablePreset from "../../../Table/TablePreset";
import "../../../Table/Table.css";
import "../../../Orders/Orders.css";
import { useNavigate, useParams } from "react-router";
import CheckboxHeader from "../../../Table/TableComponents/CheckboxHeader";
import CheckboxCell from "../../../Table/TableComponents/CheckboxCell";
import SortableHeader from "../../../Table/TableComponents/SortableHeader";
import Trash from "../Icons/trash-can.svg";
import ToastError from "../../../Toasts/ToastError";
import Downloaden from "../Icons/download.svg";
import ToastSuccess from "../../../Toasts/ToastSuccess";
import TDSTextNavigation from "../../../Templates/TDSTextNavigation";
import { use } from "react";

import { generateInvoice } from '../../../generatePDF/GenerateInvoice';


const Invoice = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [orderIds, setOrderIds] = useState([]);
  const [pagination, setPagination] = useState({
    page_size: 10,
    page: 1,
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  });
  const [order, setOrder] = useState({ orderBy: "", direction: "" });
  const [searchBar, setSearchBar] = useState("");
  const [rowToDelete, setRowToDelete] = useState(null);
  const { internal_id } = useParams();

  const fetchAll = async () => {
    setLoading(true);
    try {
      const searchQuery = searchBar.trim() ? `&searchTerm=${encodeURIComponent(searchBar.trim())}&noSearch=["invoice_id", "internal_id", "creator_user_id", "note", "order_number", "status", "updated_at", "updator_user_id", "created_at"]` : "";
      const [offersResponse, test] = await Promise.all([
        middleware.get(
          `invoices?page=${pagination.page
          }&internal_id=${internal_id}&page_size=${pagination.page_size}${order.orderBy !== "" && order.direction !== ""
            ? `&orderBy=${order.orderBy}&direction=${order.direction}`
            : ""
          }${searchQuery}`
        )
      ]);
      setData(offersResponse.data.data.data);
      setPagination({
        ...pagination,
        max_items: offersResponse.data.data.total,
        begin_of_page: offersResponse.data.data.from,
        end_of_page: offersResponse.data.data.to,
      });
    } catch (error) {
      // Handle errors here
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  const fetchOrder = async (orderNumber) => {
    try {
      const [orderResponse,] = await Promise.all([
        middleware.get(
          `orders?order_number=${orderNumber}`
        ),
      ]);
      return orderResponse.data.data[0];
    } catch (error) {
      console.error("Error fetching order data:", error);
      return null;
    }
  };

  const fetchCustomer = async (internal_id) => {
    try {
      const [response] = await Promise.all([
        middleware.get(
          `sp/customerHubOverview?internal_id=${internal_id}`
        ),
      ]);
      return response.data[0];
    } catch (error) {
      console.error("Error fetching customer data:", error);
      return null;
    }
  };

  const fetchCompanyInfo = async (internal_id) => {
    try {
      const [response] = await Promise.all([
        middleware.get(
          `settings/backoffice`
        ),
      ]);
      return response.data.data[0];
    } catch (error) {
      console.error("Error fetching customer data:", error);
      return null;
    }
  };

  const fetchDeliveryAdress = async (delivery_address_id) => {
    try {
      const [response] = await Promise.all([
        middleware.get(
          `addresses?address_id=${delivery_address_id}`
        ),
      ]);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching delivery address:", error);
      return null;
    }
  };

const fetchProducts = async (order_id) => {
  try {
    const response = await middleware.get(
      `orders/soldproducts?order_id=${order_id}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return null;
  }
};

  useEffect(() => {
    try {
      fetchAll();
    } catch (error) {
      console.warn(error);
    }
  }, [pagination.page_size, pagination.page, order, order.direction, searchBar]);

  const [selectedIds, setSelectedIds] = useState([]);

  // Handle checkbox selection
  const handleSelection = (productId, isSelected) => {
    if (isSelected) {
      setSelectedIds((previous) => [...previous, productId]);
    } else {
      setSelectedIds((previous) => previous.filter((id) => id !== productId));
    }
  };

  const GetStatus = ({ Status }) => {
    switch (Status) {
      case 0:
        return <label className="text-danger">Concept</label>;
      case 1:
        return <label className="text-warning">Openstaand</label>;
      case 2:
        return <label className="text-info">Deels betaald</label>;
      case 3:
        return <label className="text-success">Volledig betaald</label>;
    }
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString("nl-NL"); // Formats the date
    const formattedTime = date.toLocaleTimeString("nl-NL", {
      hour: "2-digit",
      minute: "2-digit",
    });

    return { formattedDate, formattedTime };
  };

  const handleSearchChange = useCallback((value) => {
    setSearchBar(value);
    setPagination(prev => ({ ...prev, page: 1 }));
  }, []);

  // Columns for the table
  const columns = useMemo(
    () => [
      {
        Header: (
          <CheckboxHeader
            currentItem={data}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            pk={"invoice_id"}
          ></CheckboxHeader>
        ),
        accessor: "select",
        Cell: ({ row }) => {
          return (
            <CheckboxCell
              row={row}
              handleSelection={handleSelection}
              selectedIds={selectedIds}
              pk={"invoice_id"}
            />
          );
        },
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={setOrder}
            pos={"start"}
            field="invoice_number"
          >
            Factuurnummer
          </SortableHeader>
        ),
        accessor: "InvoiceNumber",
        Cell: ({ row }) => {
          return (
            <div onClick={() => generateInvoice([row.original.order_id], false, true, false)} className="d-flex flex-column" style={{ color: "#009fe3" }}>
              <TDSTextNavigation text={row.original.invoice_number} className="mb-0" />
            </div>
          );
        },
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={setOrder}
            classNameHeader={"TypeAdressInfoHeader"}
            field="billed_on"
          >
            Factuur datum
          </SortableHeader>
        ),
        accessor: "billed_on",
        Cell: ({ row }) => {
          const { formattedDate, formattedTime } = formatDateTime(
            row.original.billed_on
          );
          return (
            <div className="text-center">
              <div>{formattedDate}</div>
              <div>{formattedTime}</div>
            </div>
          );
        },
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={setOrder}
            classNameHeader={"TypeAdressInfoHeader"}
            field="price"
          >
            Waarde (excl. BTW)
          </SortableHeader>
        ),
        accessor: "price",
        Cell: ({ row }) => {
          return (
            <div className="text-center">
              <div>
                €{" "}
                {parseFloat(row.original.total_price_excl_tax).toLocaleString("nl-NL", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </div>
            </div>
          );
        },
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={setOrder}
            classNameHeader={"TypeAdressInfoHeader"}
            field="status"
          >
            Status
          </SortableHeader>
        ),
        accessor: "status",
        Cell: ({ row }) => {
          return (
            <div className="text-center">
              <GetStatus Status={row.original.status} />
            </div>
          );
        },
      },
    ],
    [order.orderBy, order.direction, selectedIds, setSelectedIds, data]
  );

  // Table instance
  const tableInstance = useTable({ columns, data: data });

  return (
    <div className="InvoiceOverviewTab h-100 mt-4">
      <div className="mb-3 tablesCustomerEdit componentMarginTop2_5 h-100">
        <TablePreset
          data={[
            {
              selectedIds: selectedIds,
              tableInstance: tableInstance,
              pagination: pagination,
              primary_key: "order_id",
            },
          ]}
          setPagination={setPagination}
          handleSelection={handleSelection}
          searchBar={[
            {
              shown: true,
              value: searchBar,
              searchFunction: handleSearchChange,
              bordered: true,
            },
          ]}
          rightButtons={[]}
        />
      </div>
    </div>
  );
};

export default Invoice;